import { createContext, useContext, useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import api from "@/lib/api";

const AuthCtx = createContext(null);
export const useAuth = () => useContext(AuthCtx);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(undefined); // undefined = checking

  useEffect(() => {
    const t = localStorage.getItem("lgw_token");
    if (!t) { setUser(null); return; }
    api.get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => { localStorage.removeItem("lgw_token"); setUser(null); });
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("lgw_token", data.token);
    setUser(data.user);
  };
  const logout = () => { localStorage.removeItem("lgw_token"); setUser(null); };

  return <AuthCtx.Provider value={{ user, login, logout }}>{children}</AuthCtx.Provider>;
}

export function RequireAdmin({ children }) {
  const { user } = useAuth();
  if (user === undefined)
    return <div className="flex min-h-screen items-center justify-center bg-linen font-sans text-sm text-muted-foreground">Loading…</div>;
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
}
